// Multi-language translations for the Full Health App (emergencycard.health)
// Supports 12+ languages

export const healthAppTranslations = {
  en: {
    // Login Page
    welcome: "Welcome",
    healthVault: "Your Health Vault",
    startWithPhone: "Start with your phone",
    noPasswordNeeded: "No password needed, just OTP",
    phoneNumber: "Phone Number",
    phoneExample: "10 digits e.g. 98765 43210",
    sendOtp: "Send OTP",
    enterOtp: "Enter OTP",
    otpSent: "OTP sent to",
    verifyLogin: "Verify & Login",
    resendOtp: "Resend OTP",
    demoMode: "Demo Mode",
    demoOtp: "Use OTP",
    blockchainSecured: "Bank-Level Security",
    tamperProof: "Your Data is Protected",
    
    // Dashboard
    dashboard: "Dashboard",
    medicalHistory: "Medical History",
    prescriptions: "Prescriptions",
    supplements: "Supplements",
    labReports: "Lab Reports",
    healthDiary: "Health Diary",
    reminders: "Reminders",
    emergencyCard: "Emergency Card",
    settings: "Settings",
    logout: "Logout",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    
    // Pricing
    choosePlan: "Choose Your Plan",
    monthly: "Monthly",
    annual: "Annual",
    lifetime: "Lifetime",
    perMonth: "/month",
    perYear: "/year",
    oneTime: "one-time",
    save17: "Save 17%",
    bestValue: "Best Value",
    mostPopular: "Most Popular",
    subscribe: "Subscribe",
    
    // Features
    fullMedicalHistory: "Full medical history tracking",
    unlimitedPrescriptions: "Unlimited prescriptions & supplements",
    healthDiaryReminders: "Health diary & reminders",
    emergencyProfile: "Emergency profile & QR code",
    pdfExport: "PDF export & sharing",
    prioritySupport: "Priority support",
    advancedInsights: "Advanced health insights",
    familyProfiles: "Family member profiles",
    comingSoon: "coming soon",
    allFutureFeatures: "All future features included",
    foundingMember: "Founding member status",
    
    flag: "🇺🇸",
    name: "English",
  },
  
  hi: {
    // Login Page
    welcome: "स्वागत है",
    welcomeBack: "वापस स्वागत है!",
    healthVault: "आपकी स्वास्थ्य तिजोरी",
    startWithPhone: "अपने फ़ोन नंबर से शुरू करें",
    noPasswordNeeded: "पासवर्ड की आवश्यकता नहीं, केवल OTP",
    phoneNumber: "फ़ोन नंबर",
    phoneExample: "10 अंक जैसे 98765 43210",
    sendOtp: "OTP भेजें",
    enterOtp: "OTP दर्ज करें",
    otpSent: "OTP भेजा गया",
    verifyLogin: "सत्यापित करें",
    resendOtp: "OTP पुनः भेजें",
    demoMode: "डेमो मोड",
    demoOtp: "OTP का उपयोग करें",
    blockchainSecured: "बैंक-स्तरीय सुरक्षा",
    tamperProof: "आपका डेटा सुरक्षित है",
    loginWithPhone: "अपने फ़ोन नंबर से लॉगिन करें",
    createAccount: "खाता बनाएं",
    existingPlan: "मौजूदा योजना",
    paymentConfirmed: "भुगतान पुष्टि",
    
    // Dashboard
    dashboard: "डैशबोर्ड",
    medicalHistory: "चिकित्सा इतिहास",
    prescriptions: "दवाइयाँ",
    supplements: "सप्लीमेंट्स",
    labReports: "लैब रिपोर्ट",
    healthDiary: "स्वास्थ्य डायरी",
    reminders: "रिमाइंडर",
    emergencyCard: "आपातकालीन कार्ड",
    settings: "सेटिंग्स",
    logout: "लॉगआउट",
    healthOverview: "स्वास्थ्य सारांश",
    recentActivity: "हाल की गतिविधि",
    quickActions: "त्वरित कार्य",
    addRecord: "रिकॉर्ड जोड़ें",
    shareWithDoctor: "डॉक्टर से साझा करें",
    viewReports: "रिपोर्ट देखें",
    referrals: "रेफरल",
    doctorAccess: "डॉक्टर एक्सेस",
    activeAccess: "सक्रिय एक्सेस",
    
    // Common
    save: "सहेजें",
    cancel: "रद्द करें",
    delete: "हटाएं",
    edit: "संपादित करें",
    add: "जोड़ें",
    loading: "लोड हो रहा है...",
    error: "त्रुटि",
    success: "सफल",
    submit: "जमा करें",
    confirm: "पुष्टि करें",
    back: "वापस",
    next: "आगे",
    done: "हो गया",
    close: "बंद करें",
    search: "खोजें",
    filter: "फ़िल्टर",
    sortBy: "क्रम से",
    noData: "कोई डेटा नहीं",
    required: "आवश्यक",
    optional: "वैकल्पिक",
    
    // Pricing
    choosePlan: "अपनी योजना चुनें",
    monthly: "मासिक",
    annual: "वार्षिक",
    lifetime: "आजीवन",
    perMonth: "/महीना",
    perYear: "/वर्ष",
    oneTime: "एक बार",
    save17: "17% बचाएं",
    bestValue: "सर्वोत्तम मूल्य",
    mostPopular: "सबसे लोकप्रिय",
    subscribe: "सदस्यता लें",
    login: "लॉगिन",
    
    // Features
    fullMedicalHistory: "संपूर्ण चिकित्सा इतिहास",
    unlimitedPrescriptions: "असीमित दवाइयाँ और सप्लीमेंट",
    healthDiaryReminders: "स्वास्थ्य डायरी और रिमाइंडर",
    emergencyProfile: "आपातकालीन प्रोफ़ाइल और QR कोड",
    pdfExport: "PDF निर्यात और साझाकरण",
    prioritySupport: "प्राथमिकता सहायता",
    advancedInsights: "उन्नत स्वास्थ्य विश्लेषण",
    familyProfiles: "परिवार के सदस्यों की प्रोफ़ाइल",
    comingSoon: "जल्द आ रहा है",
    allFutureFeatures: "सभी भविष्य की सुविधाएं शामिल",
    foundingMember: "संस्थापक सदस्य का दर्जा",
    
    // Health Terms
    bloodPressure: "रक्तचाप",
    bloodSugar: "रक्त शर्करा",
    weight: "वजन",
    temperature: "तापमान",
    heartRate: "हृदय गति",
    bloodGroup: "रक्त समूह",
    allergies: "एलर्जी",
    medications: "दवाइयाँ",
    conditions: "स्वास्थ्य स्थितियाँ",
    
    // Vault/PIN
    secureVault: "सुरक्षित तिजोरी",
    createPin: "अपना PIN बनाएं",
    enterPin: "अपना 6-अंकों का PIN दर्ज करें",
    confirmPin: "PIN की पुष्टि करें",
    unlockVault: "तिजोरी खोलें",
    changePin: "PIN बदलें",
    forgotPin: "PIN भूल गए?",
    pinRequired: "आपके स्वास्थ्य डेटा की सुरक्षा के लिए PIN आवश्यक है",
    strongPin: "कृपया एक मजबूत PIN चुनें",
    pinMismatch: "PIN मेल नहीं खाते",
    incorrectPin: "गलत PIN",
    
    // Settings
    profile: "प्रोफ़ाइल",
    accountRecovery: "खाता पुनर्प्राप्ति",
    exportData: "डेटा निर्यात करें",
    language: "भाषा",
    privacyPolicy: "गोपनीयता नीति",
    termsOfService: "सेवा की शर्तें",
    version: "संस्करण",
    
    // Emergency Card
    emergencyContacts: "आपातकालीन संपर्क",
    scanQr: "QR स्कैन करें",
    downloadQr: "QR डाउनलोड करें",
    printCard: "कार्ड प्रिंट करें",
    shareCard: "कार्ड साझा करें",
    
    // Family
    familyMembers: "परिवार के सदस्य",
    addFamilyMember: "सदस्य जोड़ें",
    relationship: "रिश्ता",
    father: "पिता",
    mother: "माता",
    spouse: "पति/पत्नी",
    child: "बच्चा",
    sibling: "भाई/बहन",
    
    // Health Diary
    howAreYouFeeling: "आज आप कैसा महसूस कर रहे हैं?",
    addEntry: "एंट्री जोड़ें",
    mood: "मनोदशा",
    symptoms: "लक्षण",
    notes: "नोट्स",
    
    // Aayu AI
    askAayu: "आयु से पूछें",
    aayuGreeting: "नमस्ते! मैं आयु हूँ, आपका स्वास्थ्य सहायक।",
    typeMessage: "अपना संदेश लिखें...",
    
    // Time
    today: "आज",
    yesterday: "कल",
    thisWeek: "इस सप्ताह",
    thisMonth: "इस महीने",
    
    // Dates
    dateFormat: "DD/MM/YYYY",
    
    flag: "🇮🇳",
    name: "हिंदी",
  },
  
  es: {
    welcome: "Bienvenido",
    healthVault: "Tu Bóveda de Salud",
    startWithPhone: "Comienza con tu teléfono",
    noPasswordNeeded: "Sin contraseña, solo OTP",
    phoneNumber: "Número de teléfono",
    phoneExample: "10 dígitos ej. 98765 43210",
    sendOtp: "Enviar OTP",
    enterOtp: "Ingresa OTP",
    otpSent: "OTP enviado a",
    verifyLogin: "Verificar e Iniciar",
    resendOtp: "Reenviar OTP",
    demoMode: "Modo Demo",
    demoOtp: "Usar OTP",
    blockchainSecured: "Seguridad Blockchain",
    tamperProof: "Registros a prueba de manipulación",
    dashboard: "Panel",
    medicalHistory: "Historial Médico",
    prescriptions: "Recetas",
    supplements: "Suplementos",
    labReports: "Análisis",
    healthDiary: "Diario de Salud",
    reminders: "Recordatorios",
    emergencyCard: "Tarjeta de Emergencia",
    settings: "Configuración",
    logout: "Cerrar Sesión",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    choosePlan: "Elige tu Plan",
    monthly: "Mensual",
    annual: "Anual",
    lifetime: "Vitalicio",
    perMonth: "/mes",
    perYear: "/año",
    oneTime: "único pago",
    save17: "Ahorra 17%",
    bestValue: "Mejor Valor",
    mostPopular: "Más Popular",
    subscribe: "Suscribirse",
    fullMedicalHistory: "Historial médico completo",
    unlimitedPrescriptions: "Recetas y suplementos ilimitados",
    healthDiaryReminders: "Diario de salud y recordatorios",
    emergencyProfile: "Perfil de emergencia y código QR",
    pdfExport: "Exportar y compartir PDF",
    prioritySupport: "Soporte prioritario",
    advancedInsights: "Análisis de salud avanzados",
    familyProfiles: "Perfiles familiares",
    comingSoon: "próximamente",
    allFutureFeatures: "Todas las funciones futuras incluidas",
    foundingMember: "Estado de miembro fundador",
    flag: "🇪🇸",
    name: "Español",
  },
  
  fr: {
    welcome: "Bienvenue",
    healthVault: "Votre Coffre Santé",
    startWithPhone: "Commencez avec votre téléphone",
    noPasswordNeeded: "Pas de mot de passe, juste OTP",
    phoneNumber: "Numéro de téléphone",
    phoneExample: "10 chiffres ex. 98765 43210",
    sendOtp: "Envoyer OTP",
    enterOtp: "Entrez OTP",
    otpSent: "OTP envoyé à",
    verifyLogin: "Vérifier et Connexion",
    resendOtp: "Renvoyer OTP",
    demoMode: "Mode Démo",
    demoOtp: "Utiliser OTP",
    blockchainSecured: "Sécurisé par Blockchain",
    tamperProof: "Dossiers inviolables",
    dashboard: "Tableau de bord",
    medicalHistory: "Historique Médical",
    prescriptions: "Ordonnances",
    supplements: "Suppléments",
    labReports: "Analyses",
    healthDiary: "Journal de Santé",
    reminders: "Rappels",
    emergencyCard: "Carte d'Urgence",
    settings: "Paramètres",
    logout: "Déconnexion",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    choosePlan: "Choisissez votre Plan",
    monthly: "Mensuel",
    annual: "Annuel",
    lifetime: "À vie",
    perMonth: "/mois",
    perYear: "/an",
    oneTime: "paiement unique",
    save17: "Économisez 17%",
    bestValue: "Meilleure Valeur",
    mostPopular: "Plus Populaire",
    subscribe: "S'abonner",
    fullMedicalHistory: "Suivi complet de l'historique médical",
    unlimitedPrescriptions: "Ordonnances et suppléments illimités",
    healthDiaryReminders: "Journal de santé et rappels",
    emergencyProfile: "Profil d'urgence et code QR",
    pdfExport: "Export et partage PDF",
    prioritySupport: "Support prioritaire",
    advancedInsights: "Analyses de santé avancées",
    familyProfiles: "Profils familiaux",
    comingSoon: "bientôt",
    allFutureFeatures: "Toutes les fonctionnalités futures incluses",
    foundingMember: "Statut de membre fondateur",
    flag: "🇫🇷",
    name: "Français",
  },
  
  de: {
    welcome: "Willkommen",
    healthVault: "Ihr Gesundheitstresor",
    startWithPhone: "Mit Telefon starten",
    noPasswordNeeded: "Kein Passwort, nur OTP",
    phoneNumber: "Telefonnummer",
    phoneExample: "10 Ziffern z.B. 98765 43210",
    sendOtp: "OTP senden",
    enterOtp: "OTP eingeben",
    otpSent: "OTP gesendet an",
    verifyLogin: "Verifizieren & Anmelden",
    resendOtp: "OTP erneut senden",
    demoMode: "Demo-Modus",
    demoOtp: "OTP verwenden",
    blockchainSecured: "Blockchain-gesichert",
    tamperProof: "Manipulationssichere Aufzeichnungen",
    dashboard: "Dashboard",
    medicalHistory: "Krankengeschichte",
    prescriptions: "Rezepte",
    supplements: "Nahrungsergänzung",
    labReports: "Laborberichte",
    healthDiary: "Gesundheitstagebuch",
    reminders: "Erinnerungen",
    emergencyCard: "Notfallkarte",
    settings: "Einstellungen",
    logout: "Abmelden",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    add: "Hinzufügen",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    choosePlan: "Wählen Sie Ihren Plan",
    monthly: "Monatlich",
    annual: "Jährlich",
    lifetime: "Lebenslang",
    perMonth: "/Monat",
    perYear: "/Jahr",
    oneTime: "einmalig",
    save17: "17% sparen",
    bestValue: "Bester Wert",
    mostPopular: "Beliebteste",
    subscribe: "Abonnieren",
    fullMedicalHistory: "Vollständige Krankengeschichte",
    unlimitedPrescriptions: "Unbegrenzte Rezepte & Ergänzungen",
    healthDiaryReminders: "Gesundheitstagebuch & Erinnerungen",
    emergencyProfile: "Notfallprofil & QR-Code",
    pdfExport: "PDF-Export & Teilen",
    prioritySupport: "Prioritäts-Support",
    advancedInsights: "Erweiterte Gesundheitsanalysen",
    familyProfiles: "Familienprofile",
    comingSoon: "demnächst",
    allFutureFeatures: "Alle zukünftigen Funktionen inklusive",
    foundingMember: "Gründungsmitglied-Status",
    flag: "🇩🇪",
    name: "Deutsch",
  },
  
  pt: {
    welcome: "Bem-vindo",
    healthVault: "Seu Cofre de Saúde",
    startWithPhone: "Comece com seu telefone",
    noPasswordNeeded: "Sem senha, apenas OTP",
    phoneNumber: "Número de telefone",
    phoneExample: "10 dígitos ex. 98765 43210",
    sendOtp: "Enviar OTP",
    enterOtp: "Digite OTP",
    otpSent: "OTP enviado para",
    verifyLogin: "Verificar e Entrar",
    resendOtp: "Reenviar OTP",
    demoMode: "Modo Demo",
    demoOtp: "Usar OTP",
    blockchainSecured: "Protegido por Blockchain",
    tamperProof: "Registros à prova de adulteração",
    dashboard: "Painel",
    medicalHistory: "Histórico Médico",
    prescriptions: "Receitas",
    supplements: "Suplementos",
    labReports: "Exames",
    healthDiary: "Diário de Saúde",
    reminders: "Lembretes",
    emergencyCard: "Cartão de Emergência",
    settings: "Configurações",
    logout: "Sair",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    add: "Adicionar",
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    choosePlan: "Escolha seu Plano",
    monthly: "Mensal",
    annual: "Anual",
    lifetime: "Vitalício",
    perMonth: "/mês",
    perYear: "/ano",
    oneTime: "pagamento único",
    save17: "Economize 17%",
    bestValue: "Melhor Valor",
    mostPopular: "Mais Popular",
    subscribe: "Assinar",
    fullMedicalHistory: "Histórico médico completo",
    unlimitedPrescriptions: "Receitas e suplementos ilimitados",
    healthDiaryReminders: "Diário de saúde e lembretes",
    emergencyProfile: "Perfil de emergência e código QR",
    pdfExport: "Exportar e compartilhar PDF",
    prioritySupport: "Suporte prioritário",
    advancedInsights: "Análises avançadas de saúde",
    familyProfiles: "Perfis familiares",
    comingSoon: "em breve",
    allFutureFeatures: "Todos os recursos futuros incluídos",
    foundingMember: "Status de membro fundador",
    flag: "🇧🇷",
    name: "Português",
  },
  
  zh: {
    welcome: "欢迎",
    healthVault: "您的健康保险库",
    startWithPhone: "用手机开始",
    noPasswordNeeded: "无需密码，只需OTP",
    phoneNumber: "电话号码",
    phoneExample: "10位数字 例如 98765 43210",
    sendOtp: "发送OTP",
    enterOtp: "输入OTP",
    otpSent: "OTP已发送至",
    verifyLogin: "验证并登录",
    resendOtp: "重新发送OTP",
    demoMode: "演示模式",
    demoOtp: "使用OTP",
    blockchainSecured: "区块链安全",
    tamperProof: "防篡改记录",
    dashboard: "仪表板",
    medicalHistory: "病历",
    prescriptions: "处方",
    supplements: "补充剂",
    labReports: "化验报告",
    healthDiary: "健康日记",
    reminders: "提醒",
    emergencyCard: "急救卡",
    settings: "设置",
    logout: "登出",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    edit: "编辑",
    add: "添加",
    loading: "加载中...",
    error: "错误",
    success: "成功",
    choosePlan: "选择您的计划",
    monthly: "月付",
    annual: "年付",
    lifetime: "终身",
    perMonth: "/月",
    perYear: "/年",
    oneTime: "一次性",
    save17: "节省17%",
    bestValue: "最佳价值",
    mostPopular: "最受欢迎",
    subscribe: "订阅",
    fullMedicalHistory: "完整病历追踪",
    unlimitedPrescriptions: "无限处方和补充剂",
    healthDiaryReminders: "健康日记和提醒",
    emergencyProfile: "急救档案和二维码",
    pdfExport: "PDF导出和分享",
    prioritySupport: "优先支持",
    advancedInsights: "高级健康分析",
    familyProfiles: "家庭成员档案",
    comingSoon: "即将推出",
    allFutureFeatures: "包含所有未来功能",
    foundingMember: "创始会员身份",
    flag: "🇨🇳",
    name: "中文",
  },
  
  ja: {
    welcome: "ようこそ",
    healthVault: "あなたの健康金庫",
    startWithPhone: "電話番号で始める",
    noPasswordNeeded: "パスワード不要、OTPのみ",
    phoneNumber: "電話番号",
    phoneExample: "10桁 例 98765 43210",
    sendOtp: "OTPを送信",
    enterOtp: "OTPを入力",
    otpSent: "OTPを送信しました",
    verifyLogin: "確認してログイン",
    resendOtp: "OTPを再送信",
    demoMode: "デモモード",
    demoOtp: "OTPを使用",
    blockchainSecured: "ブロックチェーン保護",
    tamperProof: "改ざん防止記録",
    dashboard: "ダッシュボード",
    medicalHistory: "病歴",
    prescriptions: "処方箋",
    supplements: "サプリメント",
    labReports: "検査結果",
    healthDiary: "健康日記",
    reminders: "リマインダー",
    emergencyCard: "緊急カード",
    settings: "設定",
    logout: "ログアウト",
    save: "保存",
    cancel: "キャンセル",
    delete: "削除",
    edit: "編集",
    add: "追加",
    loading: "読み込み中...",
    error: "エラー",
    success: "成功",
    choosePlan: "プランを選択",
    monthly: "月額",
    annual: "年額",
    lifetime: "永久",
    perMonth: "/月",
    perYear: "/年",
    oneTime: "一回払い",
    save17: "17%節約",
    bestValue: "最高の価値",
    mostPopular: "最も人気",
    subscribe: "購読する",
    fullMedicalHistory: "完全な病歴追跡",
    unlimitedPrescriptions: "無制限の処方箋とサプリメント",
    healthDiaryReminders: "健康日記とリマインダー",
    emergencyProfile: "緊急プロファイルとQRコード",
    pdfExport: "PDF出力と共有",
    prioritySupport: "優先サポート",
    advancedInsights: "高度な健康分析",
    familyProfiles: "家族プロファイル",
    comingSoon: "近日公開",
    allFutureFeatures: "すべての将来の機能を含む",
    foundingMember: "創設メンバーステータス",
    flag: "🇯🇵",
    name: "日本語",
  },
  
  ko: {
    welcome: "환영합니다",
    healthVault: "건강 금고",
    startWithPhone: "전화번호로 시작",
    noPasswordNeeded: "비밀번호 불필요, OTP만",
    phoneNumber: "전화번호",
    phoneExample: "10자리 예: 98765 43210",
    sendOtp: "OTP 보내기",
    enterOtp: "OTP 입력",
    otpSent: "OTP 전송됨",
    verifyLogin: "확인 및 로그인",
    resendOtp: "OTP 재전송",
    demoMode: "데모 모드",
    demoOtp: "OTP 사용",
    blockchainSecured: "블록체인 보안",
    tamperProof: "위변조 방지 기록",
    dashboard: "대시보드",
    medicalHistory: "병력",
    prescriptions: "처방전",
    supplements: "보충제",
    labReports: "검사 결과",
    healthDiary: "건강 일기",
    reminders: "알림",
    emergencyCard: "응급 카드",
    settings: "설정",
    logout: "로그아웃",
    save: "저장",
    cancel: "취소",
    delete: "삭제",
    edit: "편집",
    add: "추가",
    loading: "로딩 중...",
    error: "오류",
    success: "성공",
    choosePlan: "플랜 선택",
    monthly: "월간",
    annual: "연간",
    lifetime: "평생",
    perMonth: "/월",
    perYear: "/년",
    oneTime: "일회성",
    save17: "17% 절약",
    bestValue: "최고의 가치",
    mostPopular: "가장 인기",
    subscribe: "구독하기",
    fullMedicalHistory: "전체 병력 추적",
    unlimitedPrescriptions: "무제한 처방전 및 보충제",
    healthDiaryReminders: "건강 일기 및 알림",
    emergencyProfile: "응급 프로필 및 QR 코드",
    pdfExport: "PDF 내보내기 및 공유",
    prioritySupport: "우선 지원",
    advancedInsights: "고급 건강 분석",
    familyProfiles: "가족 프로필",
    comingSoon: "곧 출시",
    allFutureFeatures: "모든 향후 기능 포함",
    foundingMember: "창립 멤버 자격",
    flag: "🇰🇷",
    name: "한국어",
  },
  
  ar: {
    welcome: "مرحباً",
    healthVault: "خزنة صحتك",
    startWithPhone: "ابدأ برقم هاتفك",
    noPasswordNeeded: "لا حاجة لكلمة مرور، فقط OTP",
    phoneNumber: "رقم الهاتف",
    phoneExample: "10 أرقام مثال 98765 43210",
    sendOtp: "إرسال OTP",
    enterOtp: "أدخل OTP",
    otpSent: "تم إرسال OTP إلى",
    verifyLogin: "تحقق وسجل الدخول",
    resendOtp: "إعادة إرسال OTP",
    demoMode: "الوضع التجريبي",
    demoOtp: "استخدم OTP",
    blockchainSecured: "مؤمن بالبلوكتشين",
    tamperProof: "سجلات مقاومة للتلاعب",
    dashboard: "لوحة التحكم",
    medicalHistory: "التاريخ الطبي",
    prescriptions: "الوصفات الطبية",
    supplements: "المكملات",
    labReports: "تقارير المختبر",
    healthDiary: "يوميات الصحة",
    reminders: "التذكيرات",
    emergencyCard: "بطاقة الطوارئ",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    add: "إضافة",
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجاح",
    choosePlan: "اختر خطتك",
    monthly: "شهري",
    annual: "سنوي",
    lifetime: "مدى الحياة",
    perMonth: "/شهر",
    perYear: "/سنة",
    oneTime: "دفعة واحدة",
    save17: "وفر 17%",
    bestValue: "أفضل قيمة",
    mostPopular: "الأكثر شعبية",
    subscribe: "اشترك",
    fullMedicalHistory: "تتبع التاريخ الطبي الكامل",
    unlimitedPrescriptions: "وصفات ومكملات غير محدودة",
    healthDiaryReminders: "يوميات الصحة والتذكيرات",
    emergencyProfile: "ملف الطوارئ ورمز QR",
    pdfExport: "تصدير ومشاركة PDF",
    prioritySupport: "دعم أولوية",
    advancedInsights: "تحليلات صحية متقدمة",
    familyProfiles: "ملفات أفراد العائلة",
    comingSoon: "قريباً",
    allFutureFeatures: "جميع الميزات المستقبلية مشمولة",
    foundingMember: "عضوية مؤسس",
    flag: "🇸🇦",
    name: "العربية",
    direction: "rtl",
  },
  
  ru: {
    welcome: "Добро пожаловать",
    healthVault: "Ваше хранилище здоровья",
    startWithPhone: "Начните с телефона",
    noPasswordNeeded: "Пароль не нужен, только OTP",
    phoneNumber: "Номер телефона",
    phoneExample: "10 цифр напр. 98765 43210",
    sendOtp: "Отправить OTP",
    enterOtp: "Введите OTP",
    otpSent: "OTP отправлен на",
    verifyLogin: "Подтвердить и войти",
    resendOtp: "Отправить OTP повторно",
    demoMode: "Демо-режим",
    demoOtp: "Использовать OTP",
    blockchainSecured: "Защита блокчейном",
    tamperProof: "Защищённые записи",
    dashboard: "Панель",
    medicalHistory: "История болезни",
    prescriptions: "Рецепты",
    supplements: "Добавки",
    labReports: "Анализы",
    healthDiary: "Дневник здоровья",
    reminders: "Напоминания",
    emergencyCard: "Экстренная карта",
    settings: "Настройки",
    logout: "Выйти",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    edit: "Редактировать",
    add: "Добавить",
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успех",
    choosePlan: "Выберите план",
    monthly: "Месячный",
    annual: "Годовой",
    lifetime: "Пожизненный",
    perMonth: "/месяц",
    perYear: "/год",
    oneTime: "разовый платёж",
    save17: "Экономия 17%",
    bestValue: "Лучшая цена",
    mostPopular: "Самый популярный",
    subscribe: "Подписаться",
    fullMedicalHistory: "Полная история болезни",
    unlimitedPrescriptions: "Неограниченные рецепты и добавки",
    healthDiaryReminders: "Дневник здоровья и напоминания",
    emergencyProfile: "Экстренный профиль и QR-код",
    pdfExport: "Экспорт и обмен PDF",
    prioritySupport: "Приоритетная поддержка",
    advancedInsights: "Расширенная аналитика здоровья",
    familyProfiles: "Профили членов семьи",
    comingSoon: "скоро",
    allFutureFeatures: "Все будущие функции включены",
    foundingMember: "Статус основателя",
    flag: "🇷🇺",
    name: "Русский",
  },
};

// Helper functions
export const getSupportedLanguages = () => {
  return Object.entries(healthAppTranslations).map(([code, data]) => ({
    code,
    name: data.name,
    flag: data.flag,
    direction: data.direction || 'ltr',
  }));
};

export const getHealthTranslation = (langCode) => {
  return healthAppTranslations[langCode] || healthAppTranslations.en;
};

export const detectBrowserLanguage = () => {
  // First check timezone - for Indian users, default to Hindi
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone === 'Asia/Kolkata' || timezone === 'Asia/Calcutta') {
      return 'hi'; // Default to Hindi for Indian users
    }
  } catch (e) {
    // Timezone detection failed, continue with browser language
  }
  
  // Fall back to browser language preference
  const browserLang = navigator.language.split('-')[0];
  return healthAppTranslations[browserLang] ? browserLang : 'en';
};

export default healthAppTranslations;
